import CloseIcon from '@mui/icons-material/Close';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
} from '@mui/material';
import React from 'react';
import { ModuleContractor } from '../../../../types/contractor';
import { ModalProps } from '../../../../types/modal';

interface Props extends ModalProps {
    contractor: ModuleContractor;
}

const ContractorPolicyModal = ({ contractor, open, onClose }: Props) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
            <DialogTitle>
                {contractor.name}'s Cancellation Policy
                <IconButton
                    onClick={onClose}
                    size='small'
                    aria-label='close'
                    sx={{ color: 'text.primary' }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText
                    sx={{
                        fontWeight: 700,
                        color: 'text.primary',
                        fontSize: '14px',
                        whiteSpace: 'pre-wrap',
                    }}
                >
                    {contractor.cancellationPolicy}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant='contained' onClick={onClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ContractorPolicyModal;
